import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { CHAT_PANEL_MESSAGES_BACKGROUND_COLOR } from '../../styles/colors';
const CONTAINER_CSS = css `
  background-color: currentColor;
  border-radius: 4px;
  font-weight: bold;
  font-size: 80%;
  padding: 0 3px;
  text-align: center;
`;
const INNER_CSS = css `
  color: ${CHAT_PANEL_MESSAGES_BACKGROUND_COLOR};
`;
export const SmileysTextChatItemDisplay = ({ text }) => (_jsx("span", { css: CONTAINER_CSS, children: _jsx("span", { css: INNER_CSS, children: text }) }));
